"use strict";

var _defineProperty = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/getPrototypeOf");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var React = require('react');

var DashboardPlugin = require('@uppy/dashboard');

var getHTMLProps = require('./getHTMLProps');

var nonHtmlPropsHaveChanged = require('./nonHtmlPropsHaveChanged');

var h = React.createElement;
/**
 * React Component that renders a Dashboard for an Uppy instance. This component
 * renders the Dashboard inline, so you can put it anywhere you want.
 */

var Dashboard = /*#__PURE__*/function (_React$Component) {
  _inherits(Dashboard, _React$Component);

  var _super = _createSuper(Dashboard);

  function Dashboard() {
    _classCallCheck(this, Dashboard);

    return _super.apply(this, arguments);
  }

  _createClass(Dashboard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.installPlugin();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.uppy !== this.props.uppy) {
        this.uninstallPlugin(prevProps);
        this.installPlugin();
      } else if (nonHtmlPropsHaveChanged(this, prevProps)) {
        var options = _objectSpread(_objectSpread({}, this.props), {}, {
          target: this.container
        });

        delete options.uppy;
        this.plugin.setOptions(options);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.uninstallPlugin();
    }
  }, {
    key: "installPlugin",
    value: function installPlugin() {
      var uppy = this.props.uppy;

      var options = _objectSpread(_objectSpread({
        id: 'react:Dashboard'
      }, this.props), {}, {
        target: this.container
      });

      delete options.uppy;
      uppy.use(DashboardPlugin, options);
      this.plugin = uppy.getPlugin(options.id);
    }
  }, {
    key: "uninstallPlugin",
    value: function uninstallPlugin() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var uppy = props.uppy;
      uppy.removePlugin(this.plugin);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      // TODO: stop exposing `validProps` as a public property and rename it to `htmlProps`
      this.validProps = getHTMLProps(this.props);
      return h('div', _objectSpread({
        ref: function ref(container) {
          _this.container = container;
        }
      }, this.validProps));
    }
  }]);

  return Dashboard;
}(React.Component);

Dashboard.defaultProps = {
  inline: true
};
module.exports = Dashboard;